export default __webpack_public_path__ + "48c8352f0a171df1b1730701823f0b9a.jpg";